<div class="div-abstratct centerWidth">
        <ng-container *ngFor="let abst of abstract_bar">
            <div class=" col-6  md:col-6 sm:col-6 lg:col-3">
                <div class="abs-img">
                    <img [src]="config.getBaseUrl()+'lnd/file/get_pic?uid=' +abst['img-uid'] "/>
                </div>
                <div class="abs-text">
                    {{abst['text']}}
                </div>
            </div>
        </ng-container>
</div>
